import { MapPinIcon } from "@heroicons/react/24/outline";

type Address = { name: string; address: string };
type AddressDetailsCardProps = { to: Address; from: Address };

export default function AddressDetailsCard({
  to,
  from,
}: AddressDetailsCardProps) {
  return (
    <section className="overflow-hidden rounded-xl border border-gray-100 bg-white">
      <div className="flex items-center gap-2 border-b border-gray-100 px-4 md:px-5 py-4.5">
        <MapPinIcon className="size-5 text-blue-600" />
        <h2 className="text-sm md:text-base font-medium text-gray-950">
          Address Details
        </h2>
      </div>

      <div className="flex flex-col gap-5 px-4 md:px-5 py-5 text-sm">
        <div className="flex flex-col">
          <span className="mb-2 text-gray-500">To</span>
          <span className="text-gray-950">{to.name}</span>
          <span className="mt-1 text-gray-950">{to.address}</span>
        </div>

        <div className="border-t border-dashed border-gray-200" />

        <div className="flex flex-col">
          <span className="mb-2 text-gray-500">From</span>
          <span className="text-gray-950">{from.name}</span>
          <span className="mt-1 text-gray-950">{from.address}</span>
        </div>
      </div>
    </section>
  );
}
